var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('marketing-recommendations',{class:_vm.disabledInAbsoluteValue ? 'absolute-val-css' : '',attrs:{"marketing_recommendations":_vm.marketing_recommendations,"form":_vm.form,"isNetworkData":_vm.isNetworkData,"campaignIsSearch":_vm.campaignIsSearch,"active_tab":_vm.active_tab,"disabledInAbsoluteValue":_vm.disabledInAbsoluteValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }